import { render } from "./NomineeContent.vue?vue&type=template&id=7125daa4"
import script from "./NomineeContent.vue?vue&type=script&lang=js"
export * from "./NomineeContent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__